import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=1f9d233e&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=1f9d233e&prod&lang=scss&scoped=true"
import style1 from "./Support.vue?vue&type=style&index=1&id=1f9d233e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d233e",
  null
  
)

export default component.exports